import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'

export const useHomeAndScroll = () => {
  const { pathname } = useLocation()
  const [scrolled, setScrolled] = useState(false)

  const isHome = pathname === '/home' || pathname === '/' || pathname.startsWith('/logout')

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 10)
    }

    window.addEventListener('scroll', handleScroll)
    handleScroll()

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  return { isHome, scrolled }
}
